import { writable } from 'svelte/store';

import photos from './photos.js';

const { subscribe, set, update } = writable({});
const sessionStorageName = 'bgPhoto';

// load from storage or select random
const storagePhoto = JSON.parse(sessionStorage.getItem(sessionStorageName));
if (storagePhoto) {
	setPhoto(storagePhoto);
}
else {
	let randomPhoto = photos[Math.floor(Math.random() * photos.length)];
	setPhoto(randomPhoto);
}

function setPhoto(photo) {
	set(photo);
	sessionStorage.setItem(sessionStorageName, JSON.stringify(photo));
}

export { photos };

export default {
	subscribe,
	setPhoto
}